import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { TransferItems } from "./transfer-items.entity";
import { TransferInfo } from "./transfer-material.entity";

@Entity('location_wise_tranfers')
export class LocationWiseTranfers {
    @PrimaryGeneratedColumn("increment", { name: 'location_wise_transfer_id' })
    locationWiseTransferId: number;

    @Column("int", {
        nullable: false,
        name: "stock_id",
        default:0
    })
    stockId: number;

    @Column("int", {
        nullable: false,
        name: "item_id"
    })
    itemId: number;

    @Column("int", {
        nullable: false,
        name: "location"
    })
    location: number;

    @Column("int", {
        nullable: false,
        name: "transferred_item_id"
    })
    transferredItemId: number;

    @Column("decimal", {
        nullable: false,
        name: "issued_qty",
        default:0,
        unsigned:true,
        precision:10,scale:3,
    })
    issuedQty: number;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => TransferItems, ress => ress.locationstockTransferItems, { nullable: false })
    @JoinColumn({ name: "transferred_item_id" })
    locationInfo: TransferItems;
}